import { glideLocalStorage } from "../glideLocalStorage";
import type { Wallet } from "@wallet-standard/base";

export type ConnectArgs = {
  wallet: Wallet;
};

export async function connect({ wallet }: ConnectArgs) {
  // Use wallet-standard connect feature
  const connectFeature = wallet.features["standard:connect"] as {
    connect: () => Promise<{ accounts: { address: string }[] }>;
  };
  if (!connectFeature) {
    throw new Error("Wallet does not support standard:connect feature");
  }

  const result = await connectFeature.connect();
  if (!result.accounts.length) {
    throw new Error("No accounts returned from wallet");
  }

  const account = result.accounts[0];
  const pk = account.address;
  if (!pk) throw new Error("No address");

  await glideLocalStorage.setItem("glide.solana.connector", wallet.name);
  await glideLocalStorage.setItem("glide.solana.account", pk);

  window.dispatchEvent(new CustomEvent("glide.solana.account"));
}
